import { SingleUserResponse, User } from '@jaunt/api';
import { get } from './base.api';

export async function getMe(retry: boolean): Promise<User> {
  const { user } = await get<SingleUserResponse>('/users/me', {}, retry);
  return user;
}
